// extracted by mini-css-extract-plugin
export default {"relatedOps":"style_relatedOps__pDva7","op":"style_op__UiI27"};